/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { 
    requestGetAppointmentsByAllAdvisers, 
    requestGetAppointmentsForAdviser, 
    requestGetAppointmentsWeekByAdviser } from "services/appointment/aboutAppoinment";
//#endregion
//#region Utils
import { getTodayWithoutHourInMillis } from "components/CustomDatePicker/utils/helpers";
//#endregion

const useSchedules = ({
    isCoordinator,
    filterFields,
    fetchData,
    helpers: {
        loadingRequest,
        toastMessage 
    },
    currentPage
}) => {
    const { advisers } = fetchData.data;
    //#region States
    const [schedulesByAllAdvisers, setSchedulesByAllAdvisers] = useState([]);
    const [schedulesWeekByAdviser, setSchedulesWeekByAdviser] = useState([]);
    const [dateFiltered, setDateFiltered] = useState(-1);
    const [triggerRequest, setTriggerRequest] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (!triggerRequest) return;
        setTriggerRequest(false);
        fillSchedules();
    }, [triggerRequest]);
    //#endregion
    //#region Functions
    const getSchedulesWithReservationAttended = (
        schedules, 
        reservationId,
        value
    ) => {
        return schedules.map(schedule => {
            return {
                ...schedule,
                appointments: schedule.appointments.map(appointment => {
                    return {
                        ...appointment,
                        reservations: appointment.reservations.map(reservation => {
                            return reservation.id === reservationId
                                ? {
                                    ...reservation,
                                    attended: value
                                } : reservation;
                        })
                    }
                })
            };
        });
    }
    const changeReservationAttendance = (reservationId, value) => {
        if (!filterFields.adviserCode) {
            setSchedulesByAllAdvisers(getSchedulesWithReservationAttended(
                schedulesByAllAdvisers,
                reservationId, value
            ));
            return;
        }
        setSchedulesWeekByAdviser(getSchedulesWithReservationAttended(
            schedulesWeekByAdviser,
            reservationId, value
        ));
    }
    const fillSchedules = async messageObj => {
        if (!advisers.length) return;
        // Verificando si disparar la petición de todos los asesores o de asesor individual
        loadingRequest.show("Cargando horarios...");
        if (!filterFields.adviserCode) await fillAppointmentSchedulesByAllAdvisers();
        else await fillAppointmentSchedulesByAdviser();
        loadingRequest.hide();
        setDateFiltered(filterFields.date);
        // Gestionando mensaje de actualización para el Toast
        manageShowToastMessage(messageObj);
    }
    const manageShowToastMessage = messageObj => {
        if (!messageObj) return;
        const { message, variant, milis } = messageObj;
        toastMessage.show(message, variant, milis);
    }
    const fillAppointmentSchedulesByAllAdvisers = async () => {
        const fetchSchedules = await requestGetAppointmentsByAllAdvisers({
            date: getFilterDateValue(), 
            page: currentPage.value
        });
        setSchedulesByAllAdvisers(fetchSchedules);
        checkIfNotReservations(fetchSchedules);
    }
    const fillAppointmentSchedulesByAdviser = async () => {
        let fetchSchedules = [];
        const filterDate = getFilterDateValue();
        const { student } = filterFields;
        if (student.id) 
            fetchSchedules = await requestGetAppointmentsForAdviser({
                studentId: student.id, 
                date: filterDate
            });
        else if (isCoordinator)
            fetchSchedules = await requestGetAppointmentsWeekByAdviser({
                adviserCode: filterFields.adviserCode,
                date: filterDate
            });
        else 
            fetchSchedules = await requestGetAppointmentsWeekByAdviser({
                date: filterDate
            });
        setSchedulesWeekByAdviser(fetchSchedules);
        checkIfNotReservations(fetchSchedules);
    }
    const getFilterDateValue = () => {
        return filterFields.date === -1 ? getTodayWithoutHourInMillis() : filterFields.date;
    }
    const checkIfNotReservations = schedules => {
        // Revisando si no existen reservas
        if (schedules.some(({ 
                appointments 
            }) => appointments.some(({ reservations }) => reservations.length > 0))) 
            return;
        toastMessage.show("No hay asesorías asignadas", "notify");
    }
    const clearSchedules = () => {
        setSchedulesByAllAdvisers([]);
        setSchedulesWeekByAdviser([]);
    }
    //#endregion
    return {
        setTriggerRequest,
        schedulesByAllAdvisers,
        schedulesWeekByAdviser,
        fillSchedules,
        clearSchedules,
        dateFiltered,
        changeReservationAttendance
    };
}

export default useSchedules;